import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, MoreVertical } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '../../components/ui/DropdownMenu';
import { youtubeCollections } from '../../src/seed';
export function YouTubeCollections() {
  const navigate = useNavigate();
  const getRelativeSyncTime = (id: string) => {
    if (id === 'yc1') return 'synced 4 hours ago';
    if (id === 'yc2') return 'synced 12 hours ago';
    return 'synced recently';
  };
  return <div className="space-y-6" data-id="element-785">
      <div className="flex items-center justify-between" data-id="element-786">
        <div data-id="element-787">
          <h1 className="text-3xl font-bold tracking-tight" data-id="element-788">Collections</h1>
          <p className="text-muted-foreground" data-id="element-789">
            YouTube channels and curated video groups
          </p>
        </div>
        <Button onClick={() => navigate('/youtube/collections/new')} data-id="element-790">
          <Plus className="mr-2 h-4 w-4" data-id="element-791" />
          New collection
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-792">
        {youtubeCollections.map(collection => <Card key={collection.id} className="cursor-pointer hover:shadow-md transition-shadow group relative" onClick={() => navigate('/youtube/library')} data-id="element-793">
            <CardHeader className="pb-3" data-id="element-794">
              <div className="flex items-start justify-between" data-id="element-795">
                <div data-id="element-796">
                  <CardTitle className="text-lg" data-id="element-797">{collection.name}</CardTitle>
                  <div className="flex items-center gap-2 mt-1.5" data-id="element-798">
                    {collection.source === 'channel' && <Badge variant="default" data-id="element-799">Channel · auto-sync</Badge>}
                    {collection.source === 'manual' && <Badge variant="secondary" data-id="element-800">Manual</Badge>}
                    {collection.source === 'empty' && <Badge variant="outline" data-id="element-801">Empty</Badge>}
                    <CardDescription className="m-0" data-id="element-802">
                      {collection.itemCount} videos
                    </CardDescription>
                  </div>
                  {collection.source === 'channel' && collection.channelHandle && <p className="text-xs text-muted-foreground mt-1.5" data-id="element-803">
                        {collection.channelHandle} ·{' '}
                        {getRelativeSyncTime(collection.id)}
                      </p>}
                </div>
                <DropdownMenu data-id="element-804">
                  <DropdownMenuTrigger asChild onClick={e => e.stopPropagation()} data-id="element-805">
                    <Button variant="ghost" size="icon" className="h-8 w-8 -mr-2 -mt-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-806">
                      <MoreVertical className="h-4 w-4" data-id="element-807" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" data-id="element-808">
                    <DropdownMenuItem onClick={e => e.stopPropagation()} data-id="element-809">
                      Edit
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={e => e.stopPropagation()} className="text-destructive" data-id="element-810">
                      Delete
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            </CardHeader>
            <CardContent data-id="element-811">
              <p className="text-sm text-muted-foreground mb-4 line-clamp-2 h-10" data-id="element-812">
                {collection.description}
              </p>
              <div className="flex gap-2" data-id="element-813">
                <div className="w-16 aspect-video rounded-sm bg-muted" data-id="element-814" />
                <div className="w-16 aspect-video rounded-sm bg-muted" data-id="element-815" />
                <div className="w-16 aspect-video rounded-sm bg-muted" data-id="element-816" />
              </div>
            </CardContent>
          </Card>)}
      </div>
    </div>;
}